import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const CheckThinIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 20 16" height="16" width="20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.4983 0.939451C19.8079 1.21464 19.8357 1.68869 19.5606 1.99828L7.56056 15.4983C7.42333 15.6527 7.2285 15.7436 7.02203 15.7497C6.81556 15.7558 6.61573 15.6764 6.46967 15.5303L0.46967 9.53034C0.176777 9.23744 0.176777 8.76257 0.46967 8.46968C0.762563 8.17678 1.23744 8.17678 1.53033 8.46968L6.96789 13.9072L18.4394 1.00174C18.7146 0.692148 19.1887 0.664263 19.4983 0.939451Z"
      fill="currentColor"
    />
  </IconBase>
);
